import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');
import fontFamily from '../data/font-family';

export const CommentText = styled.div`
  color: ${colors.black};
  font-family: ${fontFamily};
  font-size: 14px;
  margin: 16px 8px;
  overflow-wrap: break-word;
  word-wrap: break-word; // non-standard name for use in IE
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/CommentText.js